import React, { useEffect, useState } from 'react';
import { fetchWorkshops } from '../api';

const WorkshopsTable = () => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    fetchWorkshops()
      .then(res => {
        setData(res.data);
        setIsLoading(false);
      })
      .catch(err => {
        console.error(err);
        setIsLoading(false);
      });
  }, []);

  return (
    <div className="container-fluid mt-4 px-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h4 className="text-black fw-bold">Workshop Visitor Entries</h4>
        <span className="badge bg-secondary">{data.length} Records Found</span>
      </div>

      {isLoading ? (
        <div className="text-center py-5">
          <div className="spinner-border text-primary" role="status"></div>
          <p className="mt-2 text-muted">Loading Data...</p>
        </div>
      ) : (
        <div className="table-responsive shadow-sm rounded">
          <table className="table table-hover table-striped table-bordered align-middle mb-0">
            <thead className="table-dark text-center align-middle">
              <tr>
                <th>ID</th>
                <th>Workshop Code</th>
                <th>Visitor Name</th>
                <th>Father/Husband Name</th>
                <th>Mobile Number</th>
                <th>Date of Birth</th>
                <th>Gender</th>
                <th>Country</th>
                <th>State</th>
                <th>City / District</th>
                <th>Address</th>
                <th>Submission Date</th>
              </tr>
            </thead>
            <tbody>
              {data.length > 0 ? (
                data.map((item, index) => (
                  <tr key={item.id || index}>
                    <td className="text-center fw-bold">{index + 1}</td>
                    
                    {/* Workshop Info */}
                    <td className="fw-semibold text-primary">{item.workshopCode}</td>
                    
                    {/* Personal Details */}
                    <td className="fw-bold">{item.visitorName}</td>
                    <td>{item.relativeName || '-'}</td>
                    
                    {/* Contact */}
                    <td className="text-center">
                      <a href={`tel:${item.mobileNumber}`} className="text-decoration-none fw-bold">
                        {item.mobileNumber}
                      </a>
                    </td>

                    <td className="text-center">
                      {item.dateOfBirth ? new Date(item.dateOfBirth).toLocaleDateString() : '-'}
                    </td>
                    <td>{item.gender}</td>

                    {/* Location */}
                    <td className="text-center">{item.country || 'India'}</td>
                    <td>{item.state || '-'}</td>
                    <td>{item.district || item.city || '-'}</td>
                    <td>
                       <span className="d-inline-block text-truncate" style={{maxWidth: '150px'}} title={item.address}>
                         {item.address || '-'}
                       </span>
                    </td>

                    {/* Submission Date */}
                    <td className="text-center small text-muted">
                      {item.submissionDate ? new Date(item.submissionDate).toLocaleString() : '-'}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="12" className="text-center py-4 text-muted">
                    No workshop entries found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default WorkshopsTable;